import * as THREE from 'three';

import { Gizmo, GizmoLineMaterial, GizmoMaterial } from './gizmo';

const pickerMaterial = new GizmoMaterial({ visible: false, transparent: false });

export class GizmoTranslate extends Gizmo {
  handleGizmos: any;
  pickerGizmos: any;

  constructor() {
    super();

    const arrowGeometry = new THREE.Mesh(new THREE.CylinderGeometry(0, 0.05, 0.2, 12, 1, false));
    arrowGeometry.position.y = 0.5;
    arrowGeometry.updateMatrix();

    const lineXGeometry = new THREE.BufferGeometry();
    lineXGeometry.setAttribute('position', new THREE.Float32BufferAttribute([0, 0, 0, 1, 0, 0], 3));

    const lineYGeometry = new THREE.BufferGeometry();
    lineYGeometry.setAttribute('position', new THREE.Float32BufferAttribute([0, 0, 0, 0, 1, 0], 3));

    const lineZGeometry = new THREE.BufferGeometry();
    lineZGeometry.setAttribute('position', new THREE.Float32BufferAttribute([0, 0, 0, 0, 0, 1], 3));

    this.handleGizmos = {
      X: [
        [
          new THREE.Mesh(arrowGeometry.geometry, new GizmoMaterial({ color: 0xff0000 })),
          [1, 0, 0],
          [0, 0, -Math.PI / 2],
        ],
        [new THREE.Line(lineXGeometry, new GizmoLineMaterial({ color: 0xff0000 }))],
      ],

      Y: [
        [new THREE.Mesh(arrowGeometry.geometry, new GizmoMaterial({ color: 0x00ff00 })), [0, 1, 0]],
        [new THREE.Line(lineYGeometry, new GizmoLineMaterial({ color: 0x00ff00 }))],
      ],

      Z: [
        [
          new THREE.Mesh(arrowGeometry.geometry, new GizmoMaterial({ color: 0x0000ff })),
          [0, 0, 1],
          [Math.PI / 2, 0, 0],
        ],
        [new THREE.Line(lineZGeometry, new GizmoLineMaterial({ color: 0x0000ff }))],
      ],

      XY: [
        [
          new THREE.Mesh(
            new THREE.PlaneGeometry(0.29, 0.29),
            new GizmoMaterial({ color: 0xffff00, opacity: 0.25 }),
          ),
          [0.15, 0.15, 0],
        ],
      ],

      YZ: [
        [
          new THREE.Mesh(
            new THREE.PlaneGeometry(0.29, 0.29),
            new GizmoMaterial({ color: 0x00ffff, opacity: 0.25 }),
          ),
          [0, 0.15, 0.15],
          [0, Math.PI / 2, 0],
        ],
      ],

      XZ: [
        [
          new THREE.Mesh(
            new THREE.PlaneGeometry(0.29, 0.29),
            new GizmoMaterial({ color: 0xff00ff, opacity: 0.25 }),
          ),
          [0.15, 0, 0.15],
          [-Math.PI / 2, 0, 0],
        ],
      ],
    };

    this.pickerGizmos = {
      X: [
        [
          new THREE.Mesh(new THREE.CylinderGeometry(0.2, 0, 1, 4, 1, false), pickerMaterial),
          [0.6, 0, 0],
          [0, 0, -Math.PI / 2],
        ],
      ],

      Y: [
        [
          new THREE.Mesh(new THREE.CylinderGeometry(0.2, 0, 1, 4, 1, false), pickerMaterial),
          [0, 0.6, 0],
        ],
      ],

      Z: [
        [
          new THREE.Mesh(new THREE.CylinderGeometry(0.2, 0, 1, 4, 1, false), pickerMaterial),
          [0, 0, 0.6],
          [Math.PI / 2, 0, 0],
        ],
      ],

      XY: [[new THREE.Mesh(new THREE.PlaneGeometry(0.4, 0.4), pickerMaterial), [0.2, 0.2, 0]]],

      YZ: [
        [
          new THREE.Mesh(new THREE.PlaneGeometry(0.4, 0.4), pickerMaterial),
          [0, 0.2, 0.2],
          [0, Math.PI / 2, 0],
        ],
      ],

      XZ: [
        [
          new THREE.Mesh(new THREE.PlaneGeometry(0.4, 0.4), pickerMaterial),
          [0.2, 0, 0.2],
          [-Math.PI / 2, 0, 0],
        ],
      ],
    };

    this.init();
  }

  setActivePlane(axis: string, cameraDirection: THREE.Vector3) {
    cameraDirection.applyMatrix4(
      new THREE.Matrix4().extractRotation(this.planes!.XY!.matrixWorld).invert(),
    );

    if (axis === 'X') {
      this.activePlane = this.planes!.XY;

      if (
        Math.abs(cameraDirection.y) > Math.abs(cameraDirection.z) &&
        Math.abs(cameraDirection.y) > Math.abs(cameraDirection.x)
      ) {
        this.activePlane = this.planes!.XZ;
      }
    }

    if (axis === 'Y') {
      this.activePlane = this.planes!.XY;

      if (
        Math.abs(cameraDirection.x) > Math.abs(cameraDirection.z) &&
        Math.abs(cameraDirection.x) > Math.abs(cameraDirection.y)
      ) {
        this.activePlane = this.planes!.YZ;
      }
    }

    if (axis === 'Z') {
      this.activePlane = this.planes!.XZ;

      if (Math.abs(cameraDirection.x) > Math.abs(cameraDirection.y)) {
        this.activePlane = this.planes!.YZ;
      }
    }

    if (axis === 'XY') {
      this.activePlane = this.planes!.XY;
    }

    if (axis === 'YZ') {
      this.activePlane = this.planes!.YZ;
    }

    if (axis === 'XZ') {
      this.activePlane = this.planes!.XZ;
    }
  }
}
